<template>
    <div class="body">
        <img :src="deviceImage" alt="">
        <div class="button" v-if="!isMobile">
            <el-button type="primary" @click="goToPage" round>請登入註冊</el-button>
        </div>
        <div class="center" v-else-if="isMobile">
            <div class="mobileButton">
                <el-button type="primary" class="mobile" @click="goToPage" round>請登入註冊</el-button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'hkcmaPage',
    data() {
        return {
            isMobile: false
        };
    },
    created() {
        this.checkDeviceType();
    },
    methods: {
        checkDeviceType() {
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        goToPage() {
            this.$router.push('/hkcma/DoctorTypes'); // 路径跳转
            // 或 this.$router.push({ name: 'routeName' }); // 命名路由
        }
    },
    computed: {
        deviceImage() {
            return this.isMobile
                ? require('../assets/HKCMA.jpg')
                : require('../assets/HKCMAPC.jpg');
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
}

img {
    width: 100%;
}

.center {
    position: absolute;
    top: 60%;
    width: 100%;
    height: 8%;
    display: flex;
    justify-content: center;
}

.button {
    position: absolute;
    top: 40%;
    left: 15%;
    width: 25%;
    height: 12%;
    border-radius: 50px;
    background-color: #f9ad17;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.356);
    transition: transform 0.2s ease;
}

.mobileButton {
    width: 60%;
    height: 100%;
    border-radius: 50px;
    background-color: #f9ad17;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.356);
    transition: transform 0.2s ease;
}

.button.clicked {
    transform: scale(0.95);
}

.el-button {
    width: 95%;
    height: 85%;
    background-color: #f7941d;
    color: white;
    font-size: 45px;
    padding: 12px 24px;
    border-radius: 50px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
}

.el-button.mobile {
    width: 93%;
    height: 80%;
    font-size: 30px;
}

@media (max-width: 1200px) {
    .el-button {
        font-size: 30px;
    }
}

@media (max-width: 760px) {
    .el-button {
        font-size: 15px;
    }
}

/* .button:hover {
    background-color: #fc7200;
} */

.el-button:hover {
    background-color: #fc7200;
}
</style>
